import { useState, useEffect } from 'react';

import { WorkflowDefinitionSummaryDto } from 'src/@types/workflow/types';
import { getWorkflowDefinitions } from 'src/services/workflow/workflowDefinitionService';

export default function useActiveWorkflowDefinitions(enabled = true) {
  const [definitions, setDefinitions] = useState<WorkflowDefinitionSummaryDto[]>([]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let isCurrent = true;

    getWorkflowDefinitions()
      .then((fetched) => {
        if (isCurrent) {
          setDefinitions(fetched.filter((definition) => definition.isActive));
        }
      })
      .catch(() => {
        if (isCurrent) {
          setDefinitions([]);
        }
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled]);

  return definitions;
}
